export default "__VITE_PUBLIC_ASSET__4df3c916__"